import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';

export const PopoverBox = styled(Box).attrs({
  padding: '10px',
  backgroundColor: 'primaryText',
  borderRadius: '5px',
})``;

export const PopoverText = styled(Text).attrs({
  color: 'background',
  size: 'small',
})``;

export const PINBox = styled(Box).attrs({
  bg: 'tabHighlight',
  width: '29px',
  height: '29px',
  borderRadius: 5,
  color: 'primaryText',
  justify: 'center',
  align: 'center',
})``;

export const ButtonContent = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  justify: 'center',
  flow: 8,
})``;

export const StyledPhoneNumber = styled(Text).attrs({
  fontWeight: 'bold',
  inline: true,
})`
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.primaryBase};
    text-decoration: underline dotted;
  }
`;
